import { useTranslation } from "react-i18next";
import { useForm } from "../utils/api";
import { Skeleton } from "@/components/ui/skeleton";
import { WizardPayload } from "./SharedTypes";
import { FC } from "react";
import FormWizard from "./FormWizard";

type ScreeningProps = {
  formId: string;
  onComplete: (payload: WizardPayload) => void;
  onBack?: () => void;
  onFirstQuestionChange?: (isFirst: boolean) => void;
  showClickWrap?: boolean;
  onClickWrapShown?: () => void;
};

const Screening:FC<ScreeningProps> = ({formId, onComplete, onBack, onFirstQuestionChange, showClickWrap, onClickWrapShown}) => {
  const { t, i18n } = useTranslation();
  const {form, isLoading: isFormLoading} = useForm(formId, {language : i18n.language})

  return (
    <Skeleton loading={isFormLoading} className="min-h-[100px] w-full">
      {form && (
        <FormWizard
          form={form}
          dunBtnTxt={t('form.buttons.next')}
          onComplete={onComplete}
          onBack={onBack}
          onFirstQuestionChange={onFirstQuestionChange}
          showClickWrap={showClickWrap}
          onClickWrapShown={onClickWrapShown}
        />
      )}
    </Skeleton>
  )
}

export default Screening;